import SalaryGuide from '@/app/modules/SalaryGuide';
import { IArticleCta } from '@/types/cms';
import { useAnalytics } from '@/utils/useAnalytics';
import classnames from 'classnames';
import Link from 'next/link';
import React from 'react';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import styles from './ArticleCallToAction.module.scss';

export type ArticleCallToActionProps = IArticleCta & {
  className?: string;
};

const ArticleCallToAction = ({ copy, cta, className, name, link }: ArticleCallToActionProps) => {
  const track = useAnalytics();

  if (name.includes('JMR AU')) {
    return <SalaryGuide />;
  }

  return (
    <div className={classnames(styles.container, className)} data-testid={'article-call-to-action'}>
      <Typography variant="h6" component="h6" className={styles.text}>
        {copy}
      </Typography>
      <Link prefetch={false} href={link} as={link} passHref>
        <Button
          variant="contained"
          color="secondary"
          href={link}
          className={styles.ctaButton}
          onClick={() => {
            track('Article CTA click', {
              name,
            });
          }}
        >
          {cta}
        </Button>
      </Link>
    </div>
  );
};

export default ArticleCallToAction;
